import type { ComponentPropsWithoutRef } from "react";
import { LoadingAnimation } from "../loading-animation/loading-animation";

function FullPageLoadingIndicator() {
  return (
    <output aria-label="Loading" tabIndex={-1}>
      <LoadingAnimation size="fullPage" />
    </output>
  );
}

export interface FullPageLoadingProps
  extends Omit<ComponentPropsWithoutRef<"div">, "children" | "className"> {}

/**
 * Full-viewport loading state for an initial app, authentication, or route check.
 * For AppShell routes, prefer AppShellContent's pending state.
 */
function FullPageLoading({ ...props }: FullPageLoadingProps) {
  return (
    <div
      {...props}
      aria-busy="true"
      className="flex min-h-dvh items-center justify-center bg-surface-low p-(--spacing-24)"
      data-slot="full-page-loading"
    >
      <FullPageLoadingIndicator />
    </div>
  );
}

export { FullPageLoading, FullPageLoadingIndicator };
